module.exports = __webpack_public_path__ + "static/img/process3.f137202.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/process3.jpg
// module id = 517
// module chunks = 2 3